var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmallRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.444,
    height: 16.655,
    viewBox: "0 0 19.444 16.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-left",
    d: "M24.055,12.945H10.167l4.569-4.569A1.39,1.39,0,0,0,12.778,6.4L6.819,12.375A2.778,2.778,0,0,0,6,14.334H6a2.778,2.778,0,0,0,.819,1.944l5.958,5.972a1.39,1.39,0,0,0,1.958-1.972l-4.569-4.556H24.055a1.389,1.389,0,0,0,0-2.778Z",
    transform: "translate(-6 -5.999)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallRight);
export default __webpack_public_path__ + "static/media/arrow-small-right.3fdc1ff1dabaffac54fc823abdef3755.svg";
export { ForwardRef as ReactComponent };